import Layout from 'lib/components/Layout'

import HeroSection from 'pages/Grimtile/Home/sections/Hero'

import { GRIMTILE_NAVIGATION } from './navigation'

const GrimtileHome = () => (
  <Layout navigation={GRIMTILE_NAVIGATION} homeHref="/grimtile" showLogo={false} navbarBackgroundColor="transparent">
    <HeroSection />
  </Layout>
)

export default GrimtileHome
